import onload from './onload'

const loadScript = (window, url) => {
  const script = window.document.createElement('script')
  script.src = url + '?8=S'
  script.onload = onload
  const entry = window.document.getElementsByTagName('script')[0]
  entry.parentNode.insertBefore(script, entry)
}

export default loadScript
